import { useQuery } from "@tanstack/react-query";
import { axiosApi } from "./axios";
import { TrackingResponse } from "@/types/fedex.type";

const getFedexTracking = async (id: string, locale: string) => {
  const response = await axiosApi.get<TrackingResponse>(`/fedex/${id}?locale=${locale}`);
  return response.data;
};

export const useGetFedexTracking = (id: string, locale: string) => {
  return useQuery({
    queryKey: ["fedexTracking", id, locale],
    queryFn: () => getFedexTracking(id, locale),
    enabled: !!id,
    gcTime: 1000 * 60 * 10,
    staleTime: 1000 * 60 * 10,
  });
};
